import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import store from '../store'

Yup.addMethod(Yup.string, "valida_rut", function (errorMessage) {
    return this.test(`valida_rut`, errorMessage, function (rut) {
     
        rut = rut && rut.split('.').join('');
        rut = rut && rut.split('-').join('');
  
      //Valor acumulado para el calculo de la formula
      var nAcumula = 0;
      //Factor por el cual se debe multiplicar el valor de la posicion
      var nFactor = 2;
      //Digito verificador
      var nDv = 0;
      var nDvReal;
      //extraemos el ultimo numero o letra que corresponde al verificador
      //La K corresponde a 10
      if (rut && rut.charAt(rut.length - 1).toUpperCase() == 'K' )
          nDvReal = 10;
      //el 0 corresponde a 11
      else if (rut && rut.charAt(rut.length - 1)== 0 )
          nDvReal = 11;
      else
          nDvReal =rut && rut.charAt(rut.length - 1);
      for (var nPos =rut &&  rut.length -2; nPos >=0; nPos--) {
          nAcumula +=rut &&  rut.charAt(nPos).valueOf() * nFactor;
          nFactor++;
          if (nFactor > 7) nFactor = 2;
      }
  
      nDv = 11-(nAcumula % 11)
      if (nDv == nDvReal) {
          return true;
      } else {
          return false;
      }
  }
  )
  })

const validationSchemasLegalizacion = Yup.object({
    numeroAviso:Yup.number().required("Este campo es obligatorio"),
     fechaCaja:Yup.date("Fecha incorrecta").required("La Fecha es obligatoria"),
    monedaPago:Yup.string().required("Este campo es obligatorio"),
    montoPago:Yup.string().required("Este campo es obligatorio"),    
    idGirador:Yup.string().required("Este campo es obligatorio").valida_rut("El ID Girador no es válido")
   
   

})
export default validationSchemasLegalizacion;